import React,{useState,useEffect} from "react";
import { useSelector } from 'react-redux';

///Styles
import { toast } from 'react-toastify';
import { FiMoreVertical } from 'react-icons/fi'
import moment from 'moment'
import { ContainerLoading, Container, TableProducts } from './styles';

///Components
import { ExportFiles } from "../ExportFiles";
import { SpaceLoader } from "../../../../loaders/spaceLoader";

///Services
import { api } from "../../../../../services/api";
import { useAuth } from "../../../../../context/AuthContext";
import { useAdministrativeContext } from "../../../../../pages/administrativePanel/administrativePanelContext";

import { formatMoney } from "../../../../../Utils/formatMoney";
import { download_csv } from "../JsonToCsv";

export function DailyBalanceDetailedInformations(){

    const [daysBalance,setDaysBalance] = useState([]);
    const [loading,setLoading] = useState(true);
    const [isOpenExportFiles, setIsOpenExportFiles] = useState(false);

    const daysDatas = useSelector(state => state.modalCentralized.datasComponent);
    const { 
        listBusinessToFilter, 
        listSalesChannelsId 
      } = useAdministrativeContext();

      const { signOut } = useAuth()


    useEffect(() => {
        async function loadBalanceDays(){
            let obj = {
                month: daysDatas.isMonthBalance.month,
                business: listBusinessToFilter,
                salesChannels: listSalesChannelsId
            }
            
            try{
                await api.post('/getBalanceDays' , obj, {
                    headers: {
                        'Content-Type': 'application/json',
                        token: localStorage.getItem('@Inoveclube:token')
                    }
                })
                .then((response) => {
                    setDaysBalance(response.data);
                    setLoading(false);
                })
            }
            catch(error){
                if(error.response){
                    if(error.response.status === 401 || error.response.status === 500){
                      signOut()
                      toast.warning('Sua sessão foi expirada')
                    }else{
                      toast.error(error.response.data.message)
                    }
                }else{
                    toast.error(error.message)
                }   
            }
        }
        loadBalanceDays();
    },[daysDatas.isMonthBalance.month,listBusinessToFilter,listSalesChannelsId,signOut]);

    function handleDownloadCSV() {
        const arr = daysBalance.map((item) => {
            return{
                dia: item.day,
                valor: Number(item.credits).toFixed(2).replace('.',',')
            }
        })

        download_csv(arr, `Faturamento Diário (${moment(daysDatas.isMonthBalance.month).format('MM/YYYY')})`)
    }


    if(loading){
        return(
            <ContainerLoading>
             <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
            </ContainerLoading>
        )
    }

    return(
        <Container>
            <div className="seeMore"> 
                <FiMoreVertical 
                    onClick={() => setIsOpenExportFiles(true)}
                />
                
                <ExportFiles 
                    handleDownloadCSV={handleDownloadCSV}
                    pdfButtonIsVisible={false}
                    isOpen={isOpenExportFiles}
                    setIsOpen={setIsOpenExportFiles}
                />
            </div>

            <TableProducts>
                <thead>
                    <tr>
                        <th>Dia</th>
                        <th>Valor</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        daysBalance.map((item) => {
                            return(
                                <tr key={item.day}>
                                    <td>{item.day}</td>
                                    <td>{formatMoney(item.credits)}</td>
                                </tr>
                            )
                        })
                    }

                    <tr>
                        <td>Total</td>
                        <td>
                            {
                                formatMoney(
                                    daysBalance.map((item) => {
                                        return item.credits
                                    })
                                    .reduce((value,next) => {
                                        return value + next
                                    },0)
                                )
                            }
                        </td>
                    </tr>
                </tbody>
            </TableProducts>
        </Container>
    )
}